import React, { useEffect, useState } from "react";
import FlavorTabShimmer from "./FlavorTabShimmer";
import DragAndDropList from "./DragAndDropList";
export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  result.forEach((item, index) => {
    item.intBannerOrder = index + 1;
  });

  return result;
};
const NonMandatoryPromotions = ({
  loading,
  promotionsList,
  handleDelete,
  handleEdit,
  handleUpdateOrder,
  IsAdmin,
  dmb = false,
}) => {
  const [itemList, setItemList] = useState([]);

  useEffect(() => {
    setItemList(promotionsList);
  }, [promotionsList]);

  const onDragEnd = (result) => {
    if (!result.destination) {
      return; // Dragged outside the list
    }

    const updatedItems = reorder(
      itemList,
      result.source.index,
      result.destination.index
    );

    setItemList(updatedItems);
  };


  return (
    <div>
      <div className="px-6 sm:px-0">
        {loading ? (
          <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4">
            <FlavorTabShimmer />
            <FlavorTabShimmer />
            <FlavorTabShimmer />
            <FlavorTabShimmer />
            <FlavorTabShimmer />
            <FlavorTabShimmer />
          </div>
        ) : (
          <>
            {!dmb && promotionsList?.length > 1 ?<div className="flex justify-end py-2">
              <button
                // style={{ height: "38px" }}
                type="button"
                onClick={() => handleUpdateOrder(itemList)}
                className="inline-flex items-center justify-center rounded-md border border-transparent bg-primary px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 sm:w-auto"
              >
                Update Order
              </button>
            </div>:null}
            {promotionsList?.length > 0 ?
            <DragAndDropList
              promotionsList={itemList}
              handleDelete={handleDelete}
              handleEdit={handleEdit}
              dragAndDrop={true}
              onDragEnd={onDragEnd}
              type={'non-mandatory'}
              IsAdmin={IsAdmin}
              dmb={dmb}
            />:<div>
            No Promotions Available
            </div>}
          </>
        )}
      </div>
    </div>
  );
};

export default NonMandatoryPromotions;
